const initialState = {
  defaultCourseType: 'BasicCourse',
  courseStringPrefix: 'courses',
  useStartAndEndTimes: false
};

export default function course(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
